export default __webpack_public_path__ + "static/media/img11.e64b6dbd.png";